import {
  Dispatch,
  SetStateAction,
  SyntheticEvent,
  useCallback,
  useState,
} from "react"

import { SwapFormField, SwapSettingsView } from "#/shared/types"

const useSwapSettings = (
  setCurrentSelector: Dispatch<SetStateAction<SwapFormField | null>>,
) => {
  const [currentSettingsMenu, setCurrentSettingsMenu] =
    useState<SwapSettingsView | null>(null)

  const slippageSettingsHandler = useCallback(() => {
    setCurrentSettingsMenu(SwapSettingsView.SLIPPAGE)
  }, [])

  const openAssetSelectorHandler = useCallback(
    (field: SwapFormField) => {
      setCurrentSettingsMenu(SwapSettingsView.ASSET_SELECTOR)
      setCurrentSelector(field)
    },
    [setCurrentSelector],
  )

  const closeSettingsMenu = useCallback(
    (e: SyntheticEvent<HTMLButtonElement>) => {
      e.preventDefault()
      setCurrentSettingsMenu(null)
    },
    [],
  )

  return {
    currentSettingsMenu,
    openSlippageSettings: slippageSettingsHandler,
    openAssetSelector: openAssetSelectorHandler,
    closeSettingsMenu,
  }
}

export default useSwapSettings
